import React from "react";
import { Container, Card, Row, Col } from "react-bootstrap";
import "../styles/OurProduct.css";

// Image Imports
import img1 from "../assets/react.png";
import img2 from "../assets/next js.png";
import img3 from "../assets/angular.png";
import img4 from "../assets/reactnative.png";
import img5 from "../assets/flutter.png";
import img6 from "../assets/ios.png";
import img7 from "../assets/mongodb.png";
import img8 from "../assets/firebase.png";
import img9 from "../assets/aws.png";
import img10 from "../assets/mysql.png";
import img11 from "../assets/postgres.png";
import img12 from "../assets/oracaldatabase.jpeg";
import img13 from "../assets/express-js.png";
import img14 from "../assets/springboot.png";
import img15 from "../assets/django.png";

// Reusable Card Component
const CardComponent = ({
  image,
  title,
  description,
}: {
  image: string;
  title: string;
  description: string;
}) => (
  <Col xs={12} sm={6} md={4} lg={4} className="mb-4">
    <Card className="tech-card" data-aos="fade-up" data-aos-duration="1000">
      <div className="card-img-wrapper">
        <img src={image} className="card-img-top" alt={title} />
      </div>
      <Card.Body className="text-center">
        <Card.Title className="tech-title">{title}</Card.Title>
        <Card.Text className="tech-description">{description}</Card.Text>
      </Card.Body>
    </Card>
  </Col>
);

// Data for Technology Stacks
const stacks = {
  "Frontend Technologies": [
    {
      image: img1,
      title: "React.js",
      description:
        "A powerful JavaScript library for building dynamic UI with component-based architecture.",
    },
    {
      image: img2,
      title: "Next.js",
      description:
        "A React framework for high-performance web applications with server-side rendering.",
    },
    {
      image: img3,
      title: "AngularJS",
      description:
        "A robust framework for dynamic single-page applications with two-way data binding.",
    },
  ],
  "Mobile Technologies": [
    {
      image: img4,
      title: "React Native",
      description:
        "A framework for building cross-platform mobile apps with JavaScript.",
    },
    {
      image: img5,
      title: "Flutter",
      description:
        "A UI toolkit for building natively compiled mobile, web, and desktop apps from one codebase.",
    },
    {
      image: img6,
      title: "iOS Development",
      description:
        "Building elegant and high-performance applications tailored for Apple devices.",
    },
  ],
  "Backend Technologies": [
    {
      image: img13,
      title: "Express.js",
      description:
        "A minimal and flexible web framework for Node.js, ideal for building APIs and web applications.",
    },
    {
      image: img14,
      title: "Spring Boot",
      description:
        "A Java-based framework for microservices and enterprise applications.",
    },
    {
      image: img15,
      title: "Django",
      description:
        "A high-level Python web framework for rapid development and security-focused applications.",
    },
  ],
  "NoSQL Databases": [
    {
      image: img7,
      title: "AWS DynamoDB",
      description:
        "A fully managed NoSQL database service supporting key-value and document data structures.",
    },
    {
      image: img8,
      title: "Firebase",
      description:
        "A backend platform by Google for developing mobile and web applications.",
    },
    {
      image: img9,
      title: "MongoDB",
      description:
        "An open-source, document-oriented NoSQL database designed for scalability and agility.",
    },
  ],
  "SQL Databases": [
    {
      image: img10,
      title: "MySQL",
      description:
        "An open-source relational database management system (RDBMS) known for reliability and performance.",
    },
    {
      image: img11,
      title: "PostgreSQL",
      description:
        "An advanced open-source RDBMS known for robustness, extensibility, and SQL compliance.",
    },
    {
      image: img12,
      title: "Oracle Database",
      description:
        "A powerful RDBMS solution known for high scalability and enterprise-grade security.",
    },
  ],
};

const Stack = () => {
  return (
    <section className="our-product-section">
      {Object.entries(stacks).map(([category, technologies]) => (
        <Container key={category} className="mb-5">
          <h2 className="category-heading">{category}</h2>
          <Row className="justify-content-center">
            {technologies.map((tech) => (
              <CardComponent key={tech.title} {...tech} />
            ))}
          </Row>
        </Container>
      ))}
    </section>
  );
};

export default Stack;
